export default __webpack_public_path__ + "static/media/AistationLogo.69d93a93.webp";